/* @flow */
import React from 'react';
import Activity from 'entities/Activity';
import ActivityActionMenuTrigger from 'payments/components/ActivityActionMenuTrigger.jsx';
import Glyph from 'components/Glyph.jsx';
import Link from 'components/Link.jsx';
import Money from 'payments/components/Money.jsx';
import RSVPDialogContainer from 'payments/containers/RSVPDialogContainer.jsx';
import RSVPDropdownContainer from 'payments/containers/RSVPDropdownContainer.jsx';
import SimpleDateIcon from 'components/SimpleDateIcon.jsx';
import Text from 'components/Text.jsx';
import TimeRange from 'components/TimeRange.jsx';
import { mountModal } from 'lib/modal';

import type {Attendance} from 'entities/ActivityRecipient'; // eslint-disable-line
import type { Sort } from 'payments/components/ActivityResponsesTable.jsx';

import './styles/ActivityListCardItem.scss';

type Props = {
  activity: Activity,
};

class ActivityListCardItem extends React.Component {
  props: Props;

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  };

  getResponseURL: Function = (sort: Sort): string => {
    return `activities/${this.props.activity.id}?sort=${sort}`;
  }

  mountRSVPModal: Function = (rsvp: ?Attendance): void => {
    mountModal(
      <RSVPDialogContainer
        initialRSVP={rsvp}
        activityId={this.props.activity.id}
      />,
      this,
    );
  }

  onTitleClick: Function = (): void => {
    const { activity } = this.props;

    if (activity.isSender()) {
      this.context.router.push(`/activities/${activity.id}`);
    } else {
      this.mountRSVPModal();
    }
  }

  // return the activity price for the recipient
  // returns ammount collected for owner.
  renderLastInfoRow() {
    const { activity } = this.props;

    if (activity.isSender()) {
      const summary = activity.getRecipientSummary();

      return (
        <Text color="jungle" weight="semibold">
          <Link to={this.getResponseURL('yes')} color="inherit">
            <span>{summary.getAttendingCount()} Yes</span>
          </Link>
          <span className="ActivityListCardItem-separator">|</span>
          <Link to={this.getResponseURL('maybe')} color="inherit">
            <span>{summary.getMaybeCount()} Maybe</span>
          </Link>
          <span className="ActivityListCardItem-separator">|</span>
          <Link to={this.getResponseURL('no')} color="inherit">
            <span>{summary.getNotAttendingCount()} No</span>
          </Link>
          {!activity.isClosed() && activity.isOrHasCollectedMoneyOnline() &&
            <span>
              <span className="ActivityListCardItem-separator">|</span>
              <Money cents={activity.getTotalCollected()} /> Collected
            </span>
          }
        </Text>
      );
    }

    return (
      <Text color="jungle" weight="semibold">
        {(() => {
          if (activity.isFree()) {
            return 'Free';
          } else {
            return <Money cents={activity.getAmountPerPerson()} />;
          }
        })()}
      </Text>
    );
  }

  render() {
    const { activity } = this.props;
    const startAt = this.props.activity.getStartAt();
    const endAt = this.props.activity.getEndAt();
    const cover = activity.getThumbnail();

    const style = {
      backgroundImage: `url(${cover.image})`,
      backgroundSize: '190px 112px',
    };


    return (
      <div className="ActivityListCardItem">
        <div className="ActivityListCardItem-cover" >
          <div
            style={style}
            className="ActivityListCardItem-cover-img"
          />
          {startAt &&
            <div className="ActivityListCardItem-cover-date">
              <SimpleDateIcon
                date={startAt}
                monthTextProps={{ color: 'lava' }}
                dayTextProps={{ color: 'pitch' }}
              />
            </div>
          }
        </div>
        <div className="ActivityListCardItem-info">
          <div className="ActivityListCardItem-info-title">
            <Link onClick={this.onTitleClick}>{activity.getTitle()}</Link>
          </div>
          <div className="ActivityListCardItem-info-sub">
            Organized by {activity.getRequester().getDisplayName()}
          </div>
          {startAt &&
            <div className="ActivityListCardItem-info-sub">
              <TimeRange
                start={startAt}
                end={endAt}
                month="long"
                year="numeric"
                day="numeric"
                hour="numeric"
                minute="numeric"
              />
            </div>
          }
          <div className="ActivityListCardItem-info-sub">
            {this.renderLastInfoRow()}
          </div>
        </div>
        <div className="ActivityListCardItem-action">
          <ActivityActionMenuTrigger activity={activity}>
            <Glyph name="ellipses" size="large" color="koala" />
          </ActivityActionMenuTrigger>
        </div>
        {!activity.isSender() &&
          <div className="ActivityListCardItem-rsvp">
            <RSVPDropdownContainer
              data-test="rsvp-dropdown"
              activity={activity}
              onRSVPChange={this.mountRSVPModal}
              level="secondary"
            />
          </div>
        }
      </div>
    );
  }
}

export default ActivityListCardItem;



// WEBPACK FOOTER //
// ./src/payments/components/ActivityListCardItem.jsx